module.exports = __webpack_public_path__ + "static/sport/bgi-h5.6bce788.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/bgi-h5.jpg
// module id = lX2g
// module chunks = 0